import * as RadixTabsPrimitive from '@radix-ui/react-tabs';
import { SegmentedControlRoot } from './segmented-control-root';
import { Button } from './segmented-control-button';
import { List } from './segmented-control-list';

// Exporting Radix Toggle Primitive for custom Toggle Group
export const GDSTabsPrimitive = RadixTabsPrimitive;

export const SegmentedControl = {
  Root: SegmentedControlRoot,
  Button,
  List,
};

SegmentedControl.Root.displayName = 'SegmentedControl';
SegmentedControl.List.displayName = 'SegmentControlList';
SegmentedControl.Button.displayName = 'SegmentControlButton';
